import { AttachmentLinkEnum, DocumentResponse } from "@akitabox/api-client";
import { Subject } from "../../../util/Subject";
export interface AttachmentDialogOpenOptions {
  /** Organization id where the attachment dialog is */
  organization: string;
  /** Building id where the attachment dialog may be */
  building: string;
  /**
   * The type of entity attachments should be created for.
   */
  entityType: AttachmentLinkEnum;
  /**
   * The id of the entity to attach documents to.
   * Undefined when we do not have the entity yet.
   * If so, handles creating attachments _after_ dialog is finished
   * */
  entityId?: string;
}

export interface AttachmentDialogCloseData {
  /**
   * Array of uploaded files & their related abx documents
   * that were created during the preceeding invocation of the dialog.
   */
  uploads: AttachmentDialogUpload[];
}

export interface AttachmentDialogUpload {
  /**
   * The abx document created when the file was uploaded
   */
  document: DocumentResponse;
  /**
   * The actual file that was uploaded
   */
  file?: File;
}

export const attachmentDialogOpened =
  new Subject<AttachmentDialogOpenOptions>();

export const attachmentDialogClosed = new Subject<AttachmentDialogCloseData>();
